"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleAbandoned = function VehicleAbandoned(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M21.9995 12C21.9954 11.8707 21.9409 11.748 21.8475 11.6584C21.7542 11.5687 21.6294 11.5192 21.5 11.5205V11.5H16.6927L12.3541 7.14705C12.3077 7.10038 12.2526 7.06336 12.1918 7.03812C12.131 7.01289 12.0658 6.99994 12 7.00003H2.5C2.36875 6.99869 2.24235 7.04953 2.14858 7.14138C2.05482 7.23323 2.00137 7.35856 2 7.4898C2 7.49325 2.00044 7.49658 2.00053 7.5H2V16.5H2.00053C2.00053 16.5035 2 16.5068 2 16.5103C2.00138 16.6415 2.05483 16.7668 2.14859 16.8587C2.24235 16.9505 2.36876 17.0014 2.5 17H3.5H4.5C4.50042 16.69 4.59675 16.3876 4.77579 16.1345C4.95482 15.8814 5.20779 15.6898 5.5 15.5861V18H4.5V19H7.5V18H6.5V15.5861C6.79221 15.6898 7.04518 15.8814 7.22422 16.1345C7.40326 16.3876 7.49959 16.69 7.5 17H16.5C16.5004 16.69 16.5968 16.3876 16.7758 16.1345C16.9548 15.8814 17.2078 15.6898 17.5 15.5861V18H16.5V19H19.5V18H18.5V15.586C18.7922 15.6897 19.0452 15.8812 19.2243 16.1344C19.4033 16.3876 19.4996 16.6899 19.5 17H21.5C21.6312 17.0014 21.7576 16.9505 21.8514 16.8587C21.9452 16.7668 21.9986 16.6415 22 16.5103C22 16.5068 21.9996 16.5035 21.9995 16.5H22V12H21.9995ZM3 8.00003H11.7924L15.2808 11.5H3V8.00003ZM18 14.5C17.5137 14.5005 17.0381 14.6426 16.6312 14.909C16.2244 15.1754 15.9039 15.5545 15.7089 16H8.29103C8.09651 15.5542 7.77614 15.1748 7.36919 14.9084C6.96225 14.642 6.48641 14.5 6 14.5C5.51359 14.5 5.03775 14.642 4.63081 14.9084C4.22386 15.1748 3.90349 15.5542 3.70897 16H3V12.5H21V16H20.2911C20.0961 15.5545 19.7757 15.1754 19.3688 14.909C18.9619 14.6426 18.4863 14.5005 18 14.5Z",
    fill: props.foregroundColor
  }));
};

VehicleAbandoned.defaultProps = {
  altText: "Vehicle Abandoned",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
VehicleAbandoned.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = VehicleAbandoned;
exports.default = _default;